<template>
  <div class="content conteudo">

    <modal-associa-video ref="modalTopicoVideo"
                        :cursos="cursos"
                        :professores="professores"
                        :videos-selecionadas="videosSelecionados"
                        :tipoVideo="videoType()"
                        @videosAssociadas="buscarVideos" />

    <modal-editar-criadores ref="ModalEditarCriadores"
                            :professores="professores"
                            @editarCriadores="editarCriadores" />

    <h1><span><i class="fas fa-book"></i> Conteúdo</span></h1>

    <div class="row mt-5">
      <div class="col-12 col-md-6">
        <h2 class="mt-1">Importar vídeo do {{ videoType() }}</h2>
      </div>
      <div class="col-12 col-md-6 text-center text-md-right">
        <router-link class="btn btn-secondary mr-3 mb-2 mb-md-0" :to="{path: '/conteudo/videos'}"><i class="fas fa-chevron-left"></i> Voltar</router-link>
      </div>
    </div>

    <div class="mb-2" v-if="false">
      <a class="btn btn-primary" href="javascript:void(0)" @click="cadastrarSelecionados()">
        Cadastrar Selecionados
      </a>
    </div>

    <div class="tab-pane fade show active" id="pills-videos" role="tabpanel" aria-labelledby="pills-videos-tab">
      <div>
        <b-link v-b-toggle="'collapse-filter-videos'" class="btn btn-secondary mr-3 mb-2 mb-md-0"><i class="fas fa-filter"></i> Filtrar lista</b-link>&#32;
        <div class="dropdown btn-acoes mb-2 mb-md-0 d-inline-block">
          <a class="btn btn-secondary dropdown-toggle" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            Ações
          </a>

          <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
            <a class="dropdown-item" href="javascript:void(0)" @click="modalAssociarVideo()">Associar à lição</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" href="javascript:void(0)" @click="modalEditarCriadores()">Editar criadores</a>
          </div>
        </div>
      </div>
    </div>

    <b-collapse id="collapse-filter-videos" class="filtros mt-3">
      <b-card>
        <form v-on:submit.prevent="buscarVideos">
          <div class="row align-items-center">
            <div class="col-12 col-md-11">
              <div class="row">
                <div class="col-12 col-md-3">
                  <div class="form-group">
                    <label>Nome do Vídeo</label>
                    <input type="text" class="form-control" placeholder="Nome do video" v-model="filtro.video" />
                  </div>
                </div>
                <div class="col-12 col-md-5" v-if="false">
                  <div class="form-group">
                    <label><input type="checkbox" v-model="filtro.createdDate" /> Filtrar por data de criação</label>
                    <date-range-picker
                      v-if="filtro.createdDate"
                      ref="picker"
                      :auto-apply="true"
                      opens="center"
                      v-model="filtro.createdDateRange"
                      :locale-data="dateRangeLocale"
                      :ranges="filtrosDateRangePredefinidos">
                    </date-range-picker>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-1">
              <button type="submit" class="btn-primary btn-filtros-busca"><i class="fas fa-search"></i></button>
            </div>
          </div>
        </form>
      </b-card>
    </b-collapse>

    <p class="text-right mt-3" v-if="quantidade"><strong>{{ quantidade }}</strong> itens</p>
    <div class="table-responsive tabela-usuarios mt-2 position-relative" v-if="videosNaoCadastrados.length">
      <table class="table" ref="resultadoTabelaVideos">
        <thead>
          <tr>
            <th><input type="checkbox" v-model="selectAll" value="true"/></th>
            <th>Nome do Vídeo</th>
            <th></th>
            <th>Link</th>
            <th>Status</th>
            <th>Coordenador</th>
            <th>Professor</th>
            <th>Data de criação</th>
            <th v-if="false">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(video, index) in videosNaoCadastrados" v-bind:key="'videoVimeo'+index">
            <template v-if="video.status !== 'uploading_error'">
              <td><input v-if="video.status === 'available'" type="checkbox" @click="alteraSelecionada(video)" v-model="videosSelecionados" :value="video"/></td>
              <td>
                <input type="text" v-if="editarNome && video.editarNome" v-model="video.name" @blur="sairInputNomeVideo(video)" @keyup.enter="sairInputNomeVideo(video)" v-focus size="100%">
                <label v-else-if="editarNome && video.editarNome === false" > {{ video.name }} </label>
                <label v-else-if="editarNome === false && video.editarNome === false" > {{ video.name }} </label>
              </td>
              <td>
                <div class="d-flex align-items-center">
                  <a href="javascript:void(0)" v-if="editarNome === false" v-b-tooltip.hover title="Editar" @click="editarNomeVideo(video)"><i class="fas fa-edit"></i></a>
                </div>
              </td>
              <td>{{ video.link }}</td>
              <td>{{ video.status }}</td>
              <td>
                <select v-if="video.status === 'available'" class="form-control" v-model="videosNaoCadastrados[index].coordenador">
                  <option value="undefined">Selecione</option>
                  <option v-for="professor in professores" :key="professor.id" :value="professor.id">{{ professor.professor }}</option>
                </select>
              </td>
              <td>
                <select v-if="video.status === 'available'" class="form-control" v-model="videosNaoCadastrados[index].professor">
                  <option value="undefined">Selecione</option>
                  <option v-for="professor in professores" :key="professor.id" :value="professor.id">{{ professor.professor }}</option>
                </select>
              </td>
              <td>{{ video.created_time | formatDatetime }}</td>
              <td v-if="false">
                <div class="d-flex align-items-center" v-if="false">
                  <a href="javascript:void(0)" v-b-tooltip.hover title="Editar" @click="editarVideo(video)"><i class="fas fa-edit"></i></a>
                  <a href="javascript:void(0)" v-b-tooltip.hover title="Excluir" @click="deletarVideo(video)"><i class="fas fa-trash-alt"></i></a>
                </div>
              </td>
            </template>
          </tr>
        </tbody>
      </table>

      <transition name="fade">
        <div class="btn-top text-center d-block" v-if="scrolled">
          <a href="javascript:void(0)" @click="scrollToTop"><i class="fas fa-chevron-circle-up"></i>ir para o topo</a>
        </div>
      </transition>

    </div>

    <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler" ref="infiniteLoading">
      <div slot="no-results">Sua busca não retornou resultados</div>
      <div slot="no-more"></div>
    </infinite-loading>

  </div>
</template>

<script>
import ModalAssociaVideo from '@/modules/Conteudo/components/ModalAssociaVideo'
import ModalEditarCriadores from '@/modules/Conteudo/components/ModalEditarCriadores'
import InfiniteLoading from 'vue-infinite-loading'
import DateRangePicker from 'vue2-daterange-picker/src/components/DateRangePicker'
import DateUtils from '@/core/util/date-utils'
import ProfessorAPI from '@/api/professor-api'
import VideoAPI from '@/api/video-api'
import CursoAPI from '@/api/curso-api'
import ModuloAPI from '@/api/modulo-api'
import LicaoAPI from '@/api/licao-api'
import Swal from 'sweetalert2'
// import ResponseUtils from '@/core/util/response-utils'

export default {
  name: 'ImportarVideoView',
  components: {
    InfiniteLoading,
    DateRangePicker,
    ModalAssociaVideo,
    ModalEditarCriadores
  },
  data () {
    return {
      pagina: 1,
      videos: [],
      todosVimeosCadastrados: [],
      quantidade: 0,
      infiniteId: new Date(),
      scrolled: false,
      selectAll: false,
      videosSelecionados: [],
      ultimoSelecionado: '',
      professores: [],
      cursos: [],
      modulos: [],
      licoes: [],
      filtro: {
        video: '',
        createdDateRange: {
          startDate: DateUtils.formatDate(DateUtils.create().subtract(1, 'month').toDate()),
          endDate: DateUtils.formatDate(new Date())
        }
      },
      editarNome: false
    }
  },
  mounted () {
    ProfessorAPI.listar().then(data => {
      this.professores = data
    })
    CursoAPI.listar().then(data => {
      this.cursos = data
    })
    ModuloAPI.listar().then(data => {
      this.modulos = data
    })
    LicaoAPI.listar().then(data => {
      this.licoes = data
    })
    VideoAPI.vimeosCadastrados().then(data => {
      this.todosVimeosCadastrados = data
    })
  },

  created () {
    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener('keydown', this.handleKeyDown)
    window.addEventListener('keyup', this.handleKeyUp)
  },

  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('keydown', this.handleKeyDown)
    window.removeEventListener('keyup', this.handleKeyUp)
  },

  watch: {
    selectAll: function (value) {
      if (value) {
        this.videosSelecionados = this.videosNaoCadastrados.filter(item => (
          item.status === 'available'
        ))
      } else {
        this.videosSelecionados = []
      }
    },
    videosNaoCadastrados: function (value) {
      if (value.length === 0) {
        this.manualLoad()
      }
    }
  },

  computed: {
    videosNaoCadastrados () {
      return this.videos.filter(video => {
        Object.assign(video, {
          editarNome: false
        })
        return !this.todosVimeosCadastrados.includes(parseInt(video.uri.split('/')[2]))
      })
    }
  },

  methods: {
    handleScroll: function (event) {
      this.scrolled = window.scrollY > 100
    },

    scrollToTop: function () {
      window.scroll({ top: 0, left: 0, behavior: 'smooth' })
    },

    handleKeyDown: function (event) {
      if (event.key === 'Shift') {
        this.shiftPressed = true
      }
    },

    handleKeyUp: function (event) {
      if (event.key === 'Shift') {
        this.shiftPressed = false
      }
    },

    videoType: function () {
      return this.$route.params.videoType
    },

    buscarVideos: function () {
      this.quantidade = 0
      this.pagina = 1
      this.infiniteId = new Date()
      this.videos = []
    },

    infiniteHandler: function ($state) {
      VideoAPI.listFromVimeo(this.pagina, this.filtro).then(data => {
        this.quantidade = data.total
        let lastPage = data.total / data.per_page
        if (lastPage < 1) {
          lastPage = 1
        }
        if (this.pagina <= lastPage) {
          this.videos.push(
            ...data.data.map(item => {
              return item
            })
          )
          $state.loaded()

          if (this.pagina === lastPage) {
            $state.complete()
          } else {
            this.pagina += 1
          }
        } else {
          $state.complete()
        }
      })
    },

    manualLoad () {
      this.distance = 100
      this.$nextTick(() => {
        this.$refs.infiniteLoading.attemptLoad()
      })
    },

    alteraSelecionada: function (video) {
      if (this.shiftPressed && this.ultimoSelecionado) {
        let maiorQueUltimo = (video.uri.split('/')[2] > this.ultimoSelecionado.uri.split('/')[2])
        let novosSelecionados = []
        novosSelecionados = this.videos.filter(item => {
          if (maiorQueUltimo) {
            return (item.uri.split('/')[2] <= video.uri.split('/')[2]) && (item.uri.split('/')[2] >= this.ultimoSelecionado.uri.split('/')[2])
          } else {
            return (item.uri.split('/')[2] <= this.ultimoSelecionado.uri.split('/')[2]) && (item.uri.split('/')[2] >= video.uri.split('/')[2])
          }
        })
        novosSelecionados.map(video => {
          !this.videosSelecionados.includes(video) && this.videosSelecionados.push(video)
        })
      }
      this.ultimoSelecionado = video
    },

    modalEditarCriadores: function () {
      if (this.videosSelecionados && this.videosSelecionados.length >= 1) {
        this.$nextTick(() => {
          this.$refs.ModalEditarCriadores.show()
        })
      } else {
        Swal.fire({
          icon: 'warning',
          showCloseButton: true,
          text: 'Selecione uma ou mais vídeos para associar editar os criadores!'
        })
      }
    },

    editarCriadores: function (coordenador, professor) {
      let newArray = []
      this.videosSelecionados.map(videoSelecionado => {
        if (coordenador) {
          videoSelecionado.coordenador = coordenador
        }
        if (professor) {
          videoSelecionado.professor = professor
        }
        newArray.push(videoSelecionado)
      })
      this.videosSelecionados = newArray
    },

    modalAssociarVideo: function () {
      if (this.videosSelecionados && this.videosSelecionados.length >= 1) {
        let videoSemCoordProf = []
        this.videoEdicao = null
        this.videosSelecionados.map(video => {
          if (!video.coordenador || video.coordenador === 'undefined' || !video.professor || video.professor === 'undefined') {
            videoSemCoordProf.push(video)
          }
        })
        this.videosSelecionados = this.videosSelecionados.sort(function (a, b) {
          return new Date(a.created_at) - new Date(b.created_at)
        })

        if (videoSemCoordProf.length === 0) {
          this.$nextTick(() => {
            this.$refs.modalTopicoVideo.show()
          })
        } else {
          Swal.fire({
            icon: 'warning',
            showCloseButton: true,
            title: 'Não foi possível cadastrar!',
            text: 'Para cadastrar os vídeos é necessário informar o professor e coordenador de todos os vídeos selecionados!'
          })
        }
      } else {
        Swal.fire({
          icon: 'warning',
          showCloseButton: true,
          text: 'Selecione uma ou mais vídeos para associar a uma lição'
        })
      }
    },

    editarNomeVideo: function (video) {
      this.editarNome = true
      video.editarNome = true
    },

    sairInputNomeVideo: function (video) {
      this.editarNome = false
      video.editarNome = false
    }
  },

  directives: {
    focus: {
      inserted (el) {
        el.focus()
      }
    }
  }
}
</script>
